import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import useUIStore from "../../store/uiStore";
import useAuthStore from "../../store/authStore";

export const menuItems = [
  {
    section: "Main",
    items: [
      {
        path: "/dashboard",
        label: "Dashboard",
        icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        badge: null,
        color: "blue",
      },
    ],
  },
  {
    section: "Reports",
    items: [
      {
        path: "/partnerReports",
        label: "Partner Reports",
        icon: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
        badge: null,
        color: "indigo",
      },
    ],
  },
  {
    section: "Master",
    items: [
      {
        path: "/service",
        label: "Service",
        icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
        badge: null,
        color: "indigo",
      },
      {
        path: "/serviceSubCategory",
        label: "Service Subcategory",
        icon: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10",
        badge: null,
        color: "purple",
      },
      {
        path: "/SOSEmergency",
        label: "SOS Emergency",
        icon: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
        badge: "urgent",
        color: "red",
      },
      {
        path: "/banner",
        label: "Banner",
        icon: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
        badge: null,
        color: "pink",
      },
      {
        path: "/fueltype",
        label: "Fuel Type",
        icon: "M13 10V3L4 14h7v7l9-11h-7z",
        badge: null,
        color: "green",
      },
      {
        path: "/cartype",
        label: "Body Type",
        icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
        badge: null,
        color: "teal",
      },
      {
        path: "/carBrand",
        label: "Car Brand",
        icon: "M12 6v6m0 0v6m0-6h6m-6 0H6",
        badge: null,
        color: "cyan",
      },
      {
        path: "/discountCoupon",
        label: "Discount Coupon",
        icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
        badge: null,
        color: "yellow",
      },
      {
        path: "/membership",
        label: "Membership",
        icon: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z",
        badge: null,
        color: "amber",
      },
      {
        path: "/city",
        label: "City Management",
        icon: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z",
        badge: null,
        color: "emerald",
      },
    ],
  },
  {
    section: "Listing",
    items: [
      {
        path: "/showUsers",
        label: "Users",
        icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z",
        badge: null,
        color: "emerald",
      },
      {
        path: "/showMembers",
        label: "Members",
        icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
        badge: null,
        color: "teal",
      },
      {
        path: "/showVender",
        label: "WC Partners",
        icon: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4",
        badge: null,
        color: "sky",
      },
      {
        path: "/venderApprovedByAdmin",
        label: "Pending Partners",
        icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
        badge: null,
        color: "orange",
      },
      {
        path: "/userJobcartApproved",
        label: "Job Cards",
        icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2",
        badge: null,
        color: "violet",
      },
      {
        path: "/viewSOSEmergency",
        label: "View SOS Emergency",
        icon: "M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z",
        badge: null,
        color: "orange",
      },
    ],
  },
  {
    section: "Settings",
    items: [
      {
        path: "/razorPay",
        label: "Razor Pay",
        icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
        badge: null,
        color: "slate",
      },
    ],
  },
];

const BADGE = {
  urgent: "bg-[#F0455A] text-white",
  new: "bg-[#3395FF] text-white",
  hot: "bg-orange-500 text-white",
  premium: "bg-purple-500 text-white",
};

export default function Sidebar({ goToTop }) {
  const { sidebarOpen, setSidebarOpen, sidebarCollapsed } = useUIStore();
  const { logout } = useAuthStore();
  const navigate = useNavigate();
  const [collapsedSections, setCollapsedSections] = useState({});
  const location = useLocation();

  const handleLogout = () => {
    setSidebarOpen(false);
    logout();
    navigate("/", { replace: true });
  };

  const handleNavClick = () => {
    goToTop();
    if (window.innerWidth < 1024) setSidebarOpen(false);
  };

  const toggleSection = (name) => setCollapsedSections((prev) => ({ ...prev, [name]: !prev[name] }));

  return (
    <>
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-screen bg-[#0C2451] text-[#B7C4DE] z-40 transform transition-all duration-300 ease-in-out flex flex-col ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 ${sidebarCollapsed ? "lg:w-16" : "lg:w-56"} w-60`}
        aria-label="Sidebar navigation"
      >
        {/* Brand */}
        <div className="h-16 shrink-0 border-b border-white/10 flex items-center justify-between px-3">
          <div className={`flex items-center gap-2.5 min-w-0 ${sidebarCollapsed ? "lg:w-full lg:justify-center" : ""}`}>
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-white">
              <img src="/assets/images/logo.png" alt="" className="h-6 w-6 object-contain" />
            </span>
            <div className={`min-w-0 ${sidebarCollapsed ? "lg:hidden" : ""}`}>
              <h1 className="truncate text-[15px] font-semibold leading-tight text-white">Real Motors</h1>
              <p className="text-[11px] leading-tight text-[#8FA3C7]">Admin Dashboard</p>
            </div>
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden rounded-lg p-2 text-slate-400 hover:bg-white/10 hover:text-white"
            aria-label="Close sidebar"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Navigation */}
        <nav className={`flex-1 min-h-0 overflow-y-auto py-3 space-y-3 sidebar-scroll ${sidebarCollapsed ? "lg:px-2" : ""}`}>
          {menuItems.map((section) => {
            const isSectionCollapsed = collapsedSections[section.section];
            return (
              <div key={section.section}>
                <button
                  onClick={() => toggleSection(section.section)}
                  className={`mb-1 mt-1 flex w-full items-center justify-between px-3 text-[11px] font-semibold uppercase tracking-wider text-[#6F86B3] hover:text-[#B7C4DE] transition-colors ${sidebarCollapsed ? "lg:hidden" : ""}`}
                  aria-expanded={!isSectionCollapsed}
                >
                  <span>{section.section}</span>
                  <svg
                    className={`h-3 w-3 transition-transform duration-200 ${isSectionCollapsed ? "-rotate-90" : ""}`}
                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {sidebarCollapsed && <div className="hidden lg:block mx-2 mb-2 border-t border-white/10" />}

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isSectionCollapsed ? "max-h-0 opacity-0" : "max-h-[1000px] opacity-100"
                  } ${sidebarCollapsed ? "lg:max-h-[1000px] lg:opacity-100" : ""}`}
                >
                  {section.items.map((item) => {
                    const isActive = location.pathname === item.path;
                                    return (
                      <NavLink
                        key={item.path}
                        to={item.path}
                        onClick={handleNavClick}
                        title={item.label}
                        aria-current={isActive ? "page" : undefined}
                        className={`group relative flex items-center gap-3 py-2.5 pl-3 pr-3 no-underline hover:no-underline transition-colors ${
                          isActive ? "bg-[#1B3A78] text-white font-semibold" : "text-[#B7C4DE] hover:bg-[#143066] hover:text-white"
                        } ${sidebarCollapsed ? "lg:justify-center lg:gap-0 lg:px-0" : ""}`}
                      >
                        {isActive && <span className="absolute left-0 top-0 bottom-0 w-[3px] bg-[#3395FF]" />}
                        <svg className={`h-[18px] w-[18px] shrink-0 ${isActive ? "text-white" : "text-[#8FA3C7] group-hover:text-white"}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d={item.icon} />
                        </svg>
                        <span className={`flex-1 truncate text-[13.5px] ${sidebarCollapsed ? "lg:hidden" : ""}`}>
                          {item.label}
                        </span>
                        {item.badge && (
                          <span className={`rounded px-1.5 py-px text-[10px] font-semibold uppercase leading-4 ${BADGE[item.badge] || "bg-slate-500 text-white"} ${sidebarCollapsed ? "lg:hidden" : ""}`}>
                            {item.badge}
                          </span>
                        )}
                      </NavLink>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="shrink-0 border-t border-white/10 p-2.5">
          <button
            type="button"
            onClick={handleLogout}
            title="Log out"
            className={`flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-[#B7C4DE] transition-colors hover:bg-red-500/15 hover:text-red-300 ${sidebarCollapsed ? "lg:justify-center lg:gap-0 lg:px-0" : ""}`}
          >
            <svg className="h-[18px] w-[18px] shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span className={`text-[13.5px] font-medium ${sidebarCollapsed ? "lg:hidden" : ""}`}>Log out</span>
          </button>
        </div>
      </aside>
    </>
  );
}
